import React from "react";
import axios from "axios";
import { Box, Typography, Button } from "@mui/material";
import { translate } from "../../i18n";
import { CustomDialog } from "components/CustomDialog";

interface IRestartACRProps {
  disabledButton: boolean;
  labelButton: string;
}

export class RestartACR extends React.Component<IRestartACRProps> {
  public state = { dialogOpen: false };
  private openRestartConfirmation(): void {
    this.setState({ dialogOpen: true });
  }
  private closeRestartConfirmation(): void {
    this.setState({ dialogOpen: false });
  }
  private async restart(): Promise<void> {
    axios.get(`/maintenance/restart`).then((res) => {
      this.setState({ dialogOpen: false });
    });
  }
  
  constructor(props: any) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <>
        <CustomDialog
          title={translate("Restart confirmation logs title")}
          message={translate("Restart confirmation logs text")}
          action={() => this.restart()}
          open={this.state.dialogOpen}
          disableAction={false}
          handleClose={() => this.closeRestartConfirmation()}
          confirmLabel={"restart"}
        />
        <Box display="flex" flexDirection="column" style={{ marginBottom: "2em" }}>
          
            <Typography variant="h6" data-cy="maintenance-restart-text">{translate("Restart explanation")}</Typography>
            <Box display="flex" alignItems="center">
            <Button
              data-cy="maintenance-restart-button"
              style={{ margin: "1em" }}
              variant="contained"
              color="primary"
              disabled={this.props.disabledButton}
              onClick={() => this.openRestartConfirmation()}>
                {this.props.labelButton}
            </Button>
          </Box>
        </Box>
      </>
    );
  }
}
